module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/demo4-bg-footer-2027bdb80cfbe40e15acf12a1f6787da.jpg";